module.exports = __webpack_public_path__ + "img/pr-7.04f8bdac.png";